import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";

import DefaultLayout from "./layouts/DefaultLayout";
import CustomLayout from "./layouts/CustomLayout";

// Pages
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Service from "./pages/Service/Service";
import Candidates from "./pages/Candidates/Candidates";
import Employers from "./pages/Employers/Employers";
import Contact from "./pages/Contact/Contact";
import Candidate from "./pages/From/Candidate/Candidate";
import Employee from "./pages/From/Employee/Employee";

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Routes>
      {/* Default Layout Pages */}
      <Route
        path="/"
        element={
          <DefaultLayout>
            <Home />
          </DefaultLayout>
        }
      />
      <Route
        path="/about"
        element={
          <DefaultLayout>
            <About />
          </DefaultLayout>
        }
      />
      <Route
        path="/service"
        element={
          <DefaultLayout>
            <Service />
          </DefaultLayout>
        }
      />
      <Route
        path="/candidates"
        element={
          <DefaultLayout>
            <Candidates />
          </DefaultLayout>
        }
      />
      <Route
        path="/employers"
        element={
          <DefaultLayout>
            <Employers />
          </DefaultLayout>
        }
      />
      <Route
        path="/contact-us"
        element={
          <DefaultLayout>
            <Contact />
          </DefaultLayout>
        }
      />

      {/* Custom Layout Pages (Forms without default header/footer) */}
      <Route
        path="/for-candidate-form"
        element={
          <CustomLayout>
            <Candidate />
          </CustomLayout>
        }
      />
      <Route
        path="/for-employer-form"
        element={
          <CustomLayout>
            <Employee />
          </CustomLayout>
        }
      />
    </Routes>
  );
};

export default App;
